import React, { useCallback, useState, useEffect, useMemo, useRef } from "react";
import useSelfpointEffect from '../common3/hooks/useSelfpointEffect'
import DotLoader from '../common3/Loaders/DotLoader'

const Effect = (props) => {
  const { extra = {}, dispatchEvent, formData,htmlTemplates = {}, id,save, value, disabled } = props;
  const { label, template = '', pageSize = 100000, lineKey, enableSelection = false, watchFormFields = [],templateId } = extra
  const [page, setPage] = useState(1)
  const [select, setSelect] = useState(value)

  let watchArray = useMemo( () => {
    // special case for builder
    if( ! formData ) {
      return [
        page,pageSize
      ]
    }
    return watchFormFields.reduce((acc, cur) => {
      acc.push(formData[cur])
      return acc
    }, [
      page, pageSize
    ])

  }, [page, pageSize,formData])


  const [loading, effect] = useSelfpointEffect({ ...props, watchArray, context: { skip: +(page-1) * (pageSize), limit: +pageSize } })

  const mountRef = useRef();



  if (!effect) {
    return <DotLoader />
  }


  return null

};


export default Effect